import { View } from "react-native"
import { Body, H3 } from "@/components/standard/BFText"

import { type ReactNode, useLayoutEffect } from "react"
import { setStatusBarOverride } from "@/stores/statusBarStyle"

function FullScreenLoaderLayout({ children }: { children: ReactNode }) {
  useLayoutEffect(() => {
    setStatusBarOverride("light")
    return () => {
      setStatusBarOverride(null)
    }
  }, [])

  return (
    <View className="flex items-center justify-center flex-1 p-6 bg-midnight-blue">
      <View className="flex">
        <View className="flex w-[200px]">{children}</View>
      </View>
    </View>
  )
}

export default function FullScreenLoader({
  children,
}: {
  children: ReactNode
}) {
  useLayoutEffect(() => {
    setStatusBarOverride("light")
    return () => {
      setStatusBarOverride(null)
    }
  }, [])

  return (
    <FullScreenLoaderLayout>
      <H3 className="text-center text-off-white">{children}</H3>
      <Body className="pt-2 text-center text-off-white">
        This may take a few seconds
      </Body>
    </FullScreenLoaderLayout>
  )
}

export function FullScreenLoaderNoContent({
  children,
}: {
  children: ReactNode
}) {
  return (
    <FullScreenLoaderLayout>
      <Body className="text-off-white">{children}</Body>
    </FullScreenLoaderLayout>
  )
}
